module.exports = __webpack_public_path__ + "2a3f78aa72c966c82d0db599f5e7144c.jpg";